import { ConditionDetail as ConditionDetailModel, ConditionDetailData, FullObject } from '@/api';
import { FCT } from '@/i18n';
import { parseOrganTitle } from '@/shared/util';

import { ActionClass } from '../activity-log.constant';
import { generateTitle } from '../activity-log.util';
import { ActivityLogDetail } from './activity-log-detail.component';

interface ConditionDetailProps {
  action: ActionClass;
  conditionDetail: ConditionDetailData | ConditionDetailModel;
  fieldName: string;
  fullObject: FullObject | null;
}

export function ConditionDetail({
  action,
  conditionDetail,
  fieldName,
  fullObject,
}: ConditionDetailProps) {
  const value =
    !conditionDetail.value && action === 'CREATE'
      ? FCT.ACTIVITY_LOGS.EMPTY_FINDING_LABEL
      : conditionDetail.value;

  if ((conditionDetail.value && action === 'UPDATE') || action === 'CREATE') {
    return (
      <ActivityLogDetail
        action={action}
        fieldName={fieldName}
        title={generateTitle(parseOrganTitle(conditionDetail.name), fullObject)}
        value={String(value)}
      />
    );
  }

  return null;
}
